import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toAppPath } from "../../lib/appNavigation";
import { useFetch } from "../../hooks/useFetch";
import { authSelector } from "../Auth/AuthSlice";
import { hasRole } from "../../lib/utility";

const RedirectUnknown = () => {
  const navigate = useNavigate();
  const { user } = useSelector(authSelector);

  useFetch(() => {
    const isAuthed = hasRole(user) && globalThis.isAuthenticated;
    navigate(isAuthed ? toAppPath("/dashboard") : "/login", { replace: true });
  });

  return null;
};

export default RedirectUnknown;
